import React from 'react'
import { StyledIcon } from '../StyledIcon'
import { StyledIconPropsType } from './types'

const PrintOutlineIcon = ({
  icon = "print-outline",
  color="plain",
  viewBox= "0 0 32 32",
  width = "32px",
  height = "32px",
  customProps,
} : StyledIconPropsType) => {
  return (
    <StyledIcon
      width={width}
      height={height}
      viewBox={viewBox}
      a11yTitle={icon}
      color={color}
      fill="none"
      {...customProps}
    >
      <path d="M8 12.0013V2.66797H24V12.0013" stroke="#5C5C5C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.99935 24H5.33268C4.62544 24 3.94716 23.719 3.44706 23.219C2.94697 22.7189 2.66602 22.0406 2.66602 21.3333V14.6667C2.66602 13.9594 2.94697 13.2811 3.44706 12.781C3.94716 12.281 4.62544 12 5.33268 12H26.666C27.3733 12 28.0515 12.281 28.5516 12.781C29.0517 13.2811 29.3327 13.9594 29.3327 14.6667V21.3333C29.3327 22.0406 29.0517 22.7189 28.5516 23.219C28.0515 23.719 27.3733 24 26.666 24H23.9993" stroke="#5C5C5C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M24 18.668H8V29.3346H24V18.668Z" stroke="#5C5C5C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>

    </StyledIcon>
  )
}

export default PrintOutlineIcon